import m from 'mithril';
import { Footer, Header, MainContent } from './ui';
import { getExcelData } from './model';

export class TopPage {
  oninit(vnode) {
    vnode.state.excelData = getExcelData();
  }

  view(vnode) {
    return [
      m(Header),
      m(MainContent, [
        m(ExcelFileSelectView, {
          excelData: vnode.state.excelData
        }),
        vnode.state.excelData.fetched ? m(DataTableView, {excelData: vnode.state.excelData}) : "",
      ]),
      m(Footer),
    ];
  }
}

class DataTableView {
  view(vnode) {
    return m(".result-data.mt-4", [
      m("h2", "Excelデータ"),
      m("table.table.table-striped", [
        m("thead", [
          m("tr", vnode.attrs.excelData.headers.map(header => m("th", [
            m(".form-check.form-check-inline", [
              m("input.form-check-input[type=checkbox]", {
                checked: header.selected,
                id: `header-${header.header}`,
                onchange: (e) => {
                  // チェックボックスの状態を更新
                  header.selected = e.target.checked;
                },
              }),
              m("label.form-check-label", {
                for: `header-${header.header}`,
              }, header.header),
            ]),
          ])))
        ]),
        m("tbody", vnode.attrs.excelData.previewData.map(row => 
          m("tr", vnode.attrs.excelData.headers.map(header => 
            m("td", row[header.header])
          ))
        )),
      ]),
      m(".row.mt-2", [
        m(".col", [
          m("button.btn.btn-primary", {
            onclick: e => {
              e.preventDefault();
              // JSONデータをダウンロード
              const blob = new Blob([vnode.attrs.excelData.getAsJson()], { type: "application/json" });
              const url = URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = vnode.attrs.excelData.jsonFileName || "data.json";
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              URL.revokeObjectURL(url);
            }
          }, "JSONデータダウンロード"),
        ]),
      ]),
    ]);
  }
}

class ExcelFileSelectView {
  view(vnode) {
    // Excelファイルアップロードコントロール
    return m(".row", [
      m(".col", [
        m("form", {
          onsubmit: (e) => {
            e.preventDefault();
            vnode.attrs.excelData.parseData();
          }
        }, [
          m("div.mb-3", [
            m("label.form-label", { for: "fileUpload" }, "Excelファイルを選択"),
            m("input.form-control", {
              type: "file",
              id: "fileUpload",
              accept: ".xlsx",
              onchange: (e) => {
                // ファイルが選択された
                const file = e.target.files[0];
                if (file) {
                  vnode.attrs.excelData.excelFile = file;
                }
              }
            })
          ]),
          m("button.btn.btn-primary[type=submit]", {
            disabled: !vnode.attrs.excelData.excelFile, // Excelファイルが選択されていないときは無効化
          }, "読み込み"),
        ]),
      ]),
    ]);    
  }
}